import createReactComponent from '../createReactComponent';
export default createReactComponent('indent-decrease', 'IconIndentDecrease', [
  ['path', { d: 'M20 6l-7 0', key: 'svg-0' }],
  ['path', { d: 'M20 12l-9 0', key: 'svg-1' }],
  ['path', { d: 'M20 18l-7 0', key: 'svg-2' }],
  ['path', { d: 'M8 8l-4 4l4 4', key: 'svg-3' }],
]);
